var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 19.3001L4.275 12.7001C4.175 12.6001 4.104 12.4917 4.062 12.3751C4.02067 12.2584 4 12.1334 4 12.0001C4 11.8667 4.02067 11.7417 4.062 11.6251C4.104 11.5084 4.175 11.4001 4.275 11.3001L10.875 4.70008C11.0583 4.51675 11.2873 4.42075 11.562 4.41208C11.8373 4.40408 12.075 4.50008 12.275 4.70008C12.475 4.88342 12.5793 5.11242 12.588 5.38708C12.596 5.66242 12.5 5.90008 12.3 6.10008L7.4 11.0001H18.575C18.8583 11.0001 19.096 11.0957 19.288 11.2871C19.4793 11.4791 19.575 11.7167 19.575 12.0001C19.575 12.2834 19.4793 12.5207 19.288 12.7121C19.096 12.9041 18.8583 13.0001 18.575 13.0001H7.4L12.3 17.9001C12.4833 18.0834 12.5793 18.3167 12.588 18.6001C12.596 18.8834 12.5 19.1167 12.3 19.3001C12.1167 19.5001 11.8833 19.6001 11.6 19.6001C11.3167 19.6001 11.075 19.5001 10.875 19.3001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.b70c4ec2ca95e305ab6243777116dd2d.svg";
export { ForwardRef as ReactComponent };